/**
 * Build the RevOps user profile image URL from the Azure CDN.
 *
 * PROD: setvi.azureedge.net/public/{companyId}/UserPhotos/{userId}/picture.png
 * DEV:  setvi.azureedge.net/publicdev/{companyId}/UserPhotos/{userId}/picture.png
 *
 * The only difference between environments is the `public` vs `publicdev`
 * container, selected from `process.env.ENVIRONMENT`.
 */
const CDN_BASE_URL = 'https://setvi.azureedge.net';

export const getRevopsProfileImage = (
  companyId?: string | number | null,
  userId?: string | number | null
): string => {
  if (!companyId || !userId) return '';

  const container =
    process.env.ENVIRONMENT === 'production' ? 'public' : 'publicdev';

  return `${CDN_BASE_URL}/${container}/${companyId}/UserPhotos/${userId}/picture.png`;
};
